import { useContext } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const DateFilter = () => {
	const {
		dictionaryWords,

		yearOfActivities,
		setFrom,
		setUntil,

		fromValue,
		setFromValue,
		untilValue,
		setUntilValue,
		setHolidayButtonActive,
	} = useContext(SportsCampsContext);

	const fromFilterHandler = (event) => {
		if (event !== null) {
			//moment format event as yyyy-mm-dd
			const fromDateString = moment(event).format("YYYY-MM-DD");
			setFrom(fromDateString);
			setFromValue(event);
		}
	};

	const removeFromFilter = () => {
		setFrom("");
		setFromValue("");
		setHolidayButtonActive(false);
	};

	const untilFilterHandler = (event) => {
		if (event !== null) {
			const untilDateString = moment(event).format("YYYY-MM-DD");
			setUntil(untilDateString);
			setUntilValue(event);
		}
	};

	const removeUntilFilter = () => {
		setUntil("");
		setUntilValue("");
		setHolidayButtonActive(false);
	};

	const inputHandler = (event) => {
		if (event && event.target.value) {
			if (
				event.keyCode !== 8 &&
				(event.keyCode < 48 || event.keyCode > 57) &&
				(event.keyCode < 96 || event.keyCode > 105)
			) {
				event.preventDefault();
			}
			const length = event.target.value.length;
			if (event.keyCode !== 8 && (length !== 1 || length !== 3)) {
				if (event.keyCode === 47 || event.keyCode === 111) {
					event.preventDefault();
				}
			}
			if (event.keyCode !== 8 && (length === 2 || length === 5)) {
				event.target.value += "/";
			}
		}
	};

	return (
		<>
			<div
				className={
					fromValue ? "datepicker calendar-hidden" : "datepicker"
				}
			>
				{dictionaryWords.from}
				<DatePicker
					dateFormat="dd/MM/yyyy"
					placeholderText="dd/mm/jjjj"
					className={"c-input__field"}
					selected={fromValue}
					onChange={fromFilterHandler}
					minDate={new Date(`${yearOfActivities}-01-01`)}
					maxDate={new Date(`${yearOfActivities + 1}-12-31`)}
					value={fromValue}
					onKeyDown={(event) => {
						inputHandler(event);
					}}
				/>
				<i
					id="erase"
					className={
						fromValue ? "fa fa-close visible" : "fa fa-close"
					}
					onClick={removeFromFilter}
				></i>
			</div>
			<div
				className={
					untilValue ? "datepicker calendar-hidden" : "datepicker"
				}
			>
				{dictionaryWords.until}
				<DatePicker
					dateFormat="dd/MM/yyyy"
					placeholderText="dd/mm/jjjj"
					className={"c-input__field"}
					selected={untilValue}
					onChange={untilFilterHandler}
					minDate={new Date(`${yearOfActivities}-01-01`)}
					maxDate={new Date(`${yearOfActivities + 1}-12-31`)}
					onKeyDown={(event) => {
						inputHandler(event);
					}}
				/>
				<i
					id="erase"
					className={
						untilValue ? "fa fa-close visible" : "fa fa-close"
					}
					onClick={removeUntilFilter}
				></i>
			</div>
		</>
	);
};

export default DateFilter;
